export const SET_PERSISTENCE = 'SET_PERSISTENCE'
export const RESET_STATE = 'RESET_STATE'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const SET_THEME_MODE = 'SET_THEME_MODE'
export const SET_GEOLOCATION = 'SET_GEOLOCATION'
export const SET_COORDS = 'SET_COORDS'